import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class BalaOutro extends Vue {
  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent">
          You have completed BALA! Thank you for your hard work.
        </div>
        <div slot="actions">
          <v-btn color="secondary" to="/home">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = BalaOutro;
